<div class="c-trophiesModal">
  <div
    class="c-trophiesModal__background"
    theming
    themingGroup="none"
    themingAsset="pl-trophy-modal-background">
    <slotcom-navigation-button
      type="close"
      topPosition="3.5"
      rightPosition="2.5"
      (click)="closeModal()"></slotcom-navigation-button>

    <slotcom-navigation-button
      type="info"
      topPosition="3.5"
      leftPosition="2.5"
      (click)="openInfo()">
    </slotcom-navigation-button>

    <div class="c-trophiesModal__leftContainer">
      <span class="e-title">{{ game()?.gameTitle }}</span>

      <img
        class="e-gameIcon"
        [src]="gameIcon()" />

      <slotcom-game-tier
        class="e-gameTier"
        [gameTier]="gameTier()">
      </slotcom-game-tier>
    </div>

    <div class="c-trophiesModal__rightContainer">
      <span class="e-title">{{ 'home.trophies-modal.title' | translate | uppercase }}</span>

      <div class="e-trophies">
        @for (trophyName of trophiesList(); track trophyName; let i = $index) {
          <slotcom-trophy
            class="e-trophies__row"
            [trophy]="trophy()"
            [currentTrophyIndex]="currentTrophyIndex()"
            [trophyIndex]="i"
            [trophyName]="trophyName"></slotcom-trophy>
        }
      </div>

      <span class="e-subtitle">{{ 'home.trophies-modal.subtitle' | translate }}</span>
    </div>
  </div>
</div>
